export const USER_TYPES = {
  AMC: 'AMC',
  APPRAISER: 'APPRAISER',
  CUSTOM: 'CUSTOM',
  LENDER: 'LENDER',
  SYSTEM: 'SYSTEM',
}
